<template lang="pug">
.bg-white.rounded.shadow-sm.p-3.h-100.zoom
  .text-center
    .p-4
      img.w-100.rounded-circle(:src="chatbot.photo")

    router-link.stretched-link.link-dark.text-decoration-none(v-if="chatbot.platform === 'lowcode'" :to="`/bot/${chatbot.id}/maps`")
      img.align-text-bottom.me-1(
        :src="platforms[chatbot.platform]",
        style="width: 1rem; height: 1rem"
      )
      | {{ chatbot.name }}
    a.stretched-link.link-dark.text-decoration-none(v-else :href="`/bot/${chatbot.id}`")
      img.align-text-bottom.me-1(
        :src="platforms[chatbot.platform]",
        style="width: 1rem; height: 1rem"
      )
      | {{ chatbot.name }}
    .p-2(v-if="chatbot.product_id")
      span.badge(:class="subscriptions.pro.class") {{ subscriptions.pro.name }}
</template>

<script>
export default {
  props: {
    chatbot: {
      type: Object,
      // eslint-disable-next-line vue/require-valid-default-prop
      default: false
    }
  },
  data: () => ({
    platforms: {
      facebook: 'https://pipe.bot/img/facebook.svg',
      telegram: 'https://pipe.bot/img/telegram.svg',
      slack: 'https://pipe.bot/img/d/m/39/c98ff8.svg',
      viber: 'https://pipe.bot/img/viber.svg',
      pipe: 'https://pipe.bot/img/logo.svg',
      lowcode: 'https://pipe.bot/img/logo.svg',
      discord: 'https://pipe.bot/img/d/m/f8/389ca1.svg'
    },
    subscriptions: {
      pro: {
        name: 'PRO',
        class: 'bg-success'
      }
    }
  })
}
</script>
